import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MovieGuessingGame from './components/MovieGuessingGame';
import SettingsPage from './components/SettingsPage';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import PrivacyPage from './components/PrivacyPage';
import { GameSettingsProvider } from './contexts/GameSettingsContext';
import useTracking from './hooks/useTracking'; // Import your custom hook
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// Your reCAPTCHA Site Key (the public key from Google reCAPTCHA admin console)
// It's common practice to store this in an environment variable for easier management
const RECAPTCHA_SITE_KEY = '6LeYT1wrAAAAANLLJ_DcACptztSy4ZUuGpdDRUmd'; // <--- REPLACE THIS WITH YOUR ACTUAL SITE KEY!

function App() {
  useTracking();

  return (
    // Re-enable Router first
    // <Router>
      <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
        <GameSettingsProvider>
          <Routes>
            <Route path="/" element={<MovieGuessingGame />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Routes>
        </GameSettingsProvider>
      </GoogleReCaptchaProvider>
    // </Router>
  );
}

export default App;